module.exports = __webpack_public_path__ + "static/media/VICTORY2.d309bef.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/VICTORY2.mp3
// module id = 302
// module chunks = 1 2 3